export function TemperMark({ className = "h-4 w-4" }) {
  return (
    <svg viewBox="0 0 96 100" fill="none" className={className} aria-hidden="true">
      <path d="M4 12H92L70 28H26L4 12Z" fill="currentColor" />
      <path d="M25 32H45V88L25 60V32Z" fill="currentColor" />
      <path d="M51 32H71V60L51 88V32Z" fill="currentColor" />
    </svg>
  );
}

export default function Logo({ dark = false, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <TemperMark className={`h-4 w-4 ${dark ? "text-paper" : "text-ink"}`} />
      <span
        className={`font-display text-lg font-extrabold tracking-tight ${
          dark ? "text-paper" : "text-ink"
        }`}
      >
        TEMPER
      </span>
    </span>
  );
}
